import { Pipe, PipeTransform } from "@angular/core";
import { IServicePrice, PriceType } from "@core/interfaces";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: 'ServicePriceText',
  pure: false
})
export class ServicePriceTextPipe implements PipeTransform {
  constructor(private translate: TranslateService) {
  }

  transform(price: IServicePrice | null | undefined): string {
    if (!price || this.isPriceType(price.priceType, PriceType.Free, 4)) {
      return '';
    }

    const currencySymbol = price.currencySymbolNative || price.currencySymbol || '';
    const fixedAmount = this.formatAmount(price.fixedAmount, currencySymbol);
    const minAmount = this.formatAmount(price.minAmount, currencySymbol);
    const maxAmount = this.formatAmount(price.maxAmount, currencySymbol);

    if (this.isPriceType(price.priceType, PriceType.FixedPrice, 1) && fixedAmount) {
      return `${this.priceLabel(PriceType.FixedPrice)}: ${fixedAmount}`;
    }

    if (this.isPriceType(price.priceType, PriceType.StartingAt, 2) && fixedAmount) {
      return `${this.priceLabel(PriceType.StartingAt)}: ${fixedAmount}`;
    }

    if (this.isPriceType(price.priceType, PriceType.Hourly, 3) && fixedAmount) {
      return `${this.priceLabel(PriceType.Hourly)}: ${fixedAmount}`;
    }

    if (this.isPriceType(price.priceType, PriceType.ContactUs, 6)) {
      return this.priceLabel(PriceType.ContactUs);
    }

    if (this.isPriceType(price.priceType, PriceType.Range, 7) && minAmount && maxAmount) {
      return `${this.priceLabel(PriceType.Range)}: ${minAmount} - ${maxAmount}`;
    }

    return '';
  }

  private formatAmount(amount: number | null | undefined, currencySymbol: string): string {
    if (amount === null || amount === undefined || !Number.isFinite(Number(amount))) {
      return '';
    }

    return `${currencySymbol}${amount}`;
  }

  private priceLabel(priceType: PriceType): string {
    return this.translate.instant(`prices.${priceType}`);
  }

  private isPriceType(
    priceType: PriceType | number | string | null | undefined,
    expectedString: PriceType,
    expectedNumber: number
  ): boolean {
    return priceType === expectedString
      || priceType === expectedNumber
      || priceType === `${expectedNumber}`;
  }
}
